import type { JSX as LocalJSX } from '@familyjs/core/components';
import React from 'react';

import { NavContext } from '../contexts/NavContext';
import OutletPageManager from '../routing/OutletPageManager';

import type { FamilyReactProps } from './FamilyReactProps';
import { FmlRouterOutletInner } from './inner-proxies';
import { createForwardRef } from './utils';

type Props = LocalJSX.FmlRouterOutlet & {
  basePath?: string;
  ref?: React.Ref<any>;
  fmlPage?: boolean;
};

interface InternalProps extends Props {
  forwardedRef?: React.ForwardedRef<HTMLFmlRouterOutletElement>;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface InternalState {}

class FmlRouterOutletContainer extends React.Component<InternalProps, InternalState> {
  context!: React.ContextType<typeof NavContext>;

  constructor(props: InternalProps) {
    super(props);
  }

  render() {
    const StackManager = this.context.getStackManager();
    const { children, forwardedRef, ...props } = this.props;

    return this.context.hasFamilyRouter() ? (
      props.fmlPage ? (
        <OutletPageManager StackManager={StackManager} routeInfo={this.context.routeInfo} {...props}>
          {children}
        </OutletPageManager>
      ) : (
        <StackManager routeInfo={this.context.routeInfo}>
          <FmlRouterOutletInner {...props} forwardedRef={forwardedRef}>
            {children}
          </FmlRouterOutletInner>
        </StackManager>
      )
    ) : (
      <FmlRouterOutletInner ref={forwardedRef} {...this.props}>
        {this.props.children}
      </FmlRouterOutletInner>
    );
  }

  static get contextType() {
    return NavContext;
  }
}

export const FmlRouterOutlet = createForwardRef<Props & FamilyReactProps, HTMLFmlRouterOutletElement>(
  FmlRouterOutletContainer,
  'FmlRouterOutlet'
);
